/**
 * Liste de paramètres
 */
export const parameters = [
  "minSurface",
  "maxSurface",
  "pieces",
  "options",
  // "batiments",
  "etages",
  "orientations",
  "minPrix",
  "maxPrix",
];

/**
 * Retrouver informations d'un programme VB
 * @param {string} programmeName
 * @returns
 */
export const getProgrammeDatas = async (programmeName) => {
  const settings = {
    mode: "cors",
  };
  let response;
  try {
    response = await fetch(
      `${process.env.REACT_APP_VB}/programme/${programmeName}`,
      settings
    );
  } catch (error) {
    console.log(error);
  }

  if (response?.ok) {
    const data = await response.json();
    return data;
  } else {
    return null;
  }
};

/**
 * Retrouver les lots VB d'une recherche
 * @param {string} lotsList
 * @param {Array} options
 * @returns
 */
export const getLots = async (
  lotsList,
  searchDetails,
  searchPrintOnly,
  printLots
) => {


  if (!lotsList?.data?.attributes?.url) {return null}

  const url = `${process.env.REACT_APP_STRAPI}${lotsList?.data?.attributes?.url}`;
  let response;

  try {
    response = await fetch(url);
  } catch (error) {
    console.log(error);
  }


  if (response?.ok) {
    const csv = await response.text();

    const legendsCSV = csv.split("\r\n")[0].split(",")
    const parsedCSV = csv.split("\r\n").slice(1).map(v => v.split(","))
    
    let lots = []

    parsedCSV.map(lot => {
      const lotDatas = {}

      legendsCSV.map((v, i) => {
        lotDatas[v] = lot[i]
      })

      lots.push(lotDatas)
    })
   
    if (searchDetails) {
      lots = lots.map((lot) => ({
        ...lot,
        printed: printLots.includes(lot.nom),
      }));
    }

    if (searchPrintOnly) {
      lots = lots.filter((lot) => printLots.includes(lot.nom));
    }

    return lots;
  } else {
    return null;
  }


};

export const getFilteredLots = (lots, infos, filters) => {

  for (const filter of filters) {

    console.log("test-filter ", filter.nom, filter.type)

    if (infos[filter.nom] || infos[`min${filter.nom}`] || infos[`max${filter.nom}`]) {

      if (filter.type === "range") {
        // filtre min
        if (infos[`min${filter.nom}`]) {
          lots = lots.filter((lot) => parseFloat(lot[filter.nom]) >= infos[`min${filter.nom}`]);
        }
        // filtre max
        if (infos[`max${filter.nom}`]) {
          lots = lots.filter((lot) => parseFloat(lot[filter.nom]) <= infos[`max${filter.nom}`]);
        }
      }

      if (filter.type === "multiselect") {
        console.log(`filtre de type ${filter.type}`)
        lots = lots.filter((lot) => infos[filter.nom].split(",").includes(lot[filter.nom]));
      }
    }
  }

  return lots;
}
